import axios from 'axios';
import { apiBase } from '../utils/config';

const instance = axios.create({
  baseURL: apiBase,
  responseType: "json",
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// instance.interceptors.response.use(
//   response => response,
//   error => {
//     const status = error.response?.status;
//     if (status === 403) {
//       alert('Access forbidden: You don’t have permission to access this resource.');
//       window.location.href = '/login';
//     }

//     return Promise.reject(error);
//   }
// );

const request = (method, url, data) => {
  const token = localStorage.getItem('access_token');
  var headers = {
    'Authorization': `Bearer ${token ?? ''}`
  };
  return new Promise((resolve, reject) => {
    (() => {
      if (method === 'get') {
        return instance.request({
          url, method, params: data, headers: headers
        });
      } else {
        return instance.request({
          url, method, data, headers: headers
        });
      }
    })()
      .then((res) => {
        resolve({
          ...res.data,
          statusCode: res.status
        });
      })
      .catch((err) => {
        reject({
          success: false,
          message: err?.response?.data?.message || "Something went wrong",
          statusCode: err?.response?.status || 500
        });
      });
  });
};

export default {
  get: (endpoint, data) => {
    return request('get', endpoint, data);
  },
  post: (endpoint, data) => {
    return request('post', endpoint, data);
  },
  put: (endpoint, data) => {
    return request('put', endpoint, data);
  },
  del: (endpoint, data) => {
    return request('delete', endpoint, data);
  },
};
